import React from "react";

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    if (message === "[INTMATH_UPLOAD_FILE]") {
      actions.handleImagePreview();
      actions.handleOCR();
      return;
    }

    actions.handleAIResponse(message);
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
